<template>
  <div>
    <div class="info-box">
      <div class="title-box">
        <p>{{ title }}申请信息</p>
      </div>
      <div class="info-content" style="padding-bottom: 0">
        <el-row :gutter="16" style="width: 100%">
          <el-col :span="24">
            <el-card class="box-card">
              <el-input
                placeholder="学生姓名"
                v-model="search.name"
                clearable
                style="width: 150px"
              ></el-input>
              <el-input
                placeholder="资助高中"
                v-model="search.school_name"
                clearable
                style="width: 150px"
              ></el-input>
              <el-input
                placeholder="申请类型"
                v-model="search.set_name"
                clearable
                style="width: 150px"
              ></el-input>
              <el-input
                placeholder="就读大学"
                v-model="search.university"
                clearable
                style="width: 150px"
              ></el-input>
              <el-select
                v-model="search.education"
                clearable
                placeholder="大学属性"
                style="width: 150px"
              >
                <el-option
                  :value="item.value"
                  :key="index"
                  v-for="(item, index) in $store.state.dictList.education"
                  :label="item.name"
                ></el-option>
              </el-select>
              <el-select
                v-model="search.audit_status"
                placeholder="审核状态"
                clearable
                style="width: 150px"
              >
                <el-option value="1" label="待审核"></el-option>
                <el-option-group label="初审">
                  <el-option value="first-2" label="初审通过"></el-option>
                  <el-option value="first-4" label="初审驳回"></el-option>
                  <el-option value="first-3" label="初审不通过"></el-option>
                </el-option-group>

                <el-option-group label="复审">
                  <el-option value="second-2" label="复审通过"></el-option>
                  <el-option value="second-4" label="复审驳回"></el-option>
                  <el-option value="second-3" label="复审不通过"></el-option>
                </el-option-group>
                <el-option-group label="复审">
                  <el-option value="third-2" label="终审通过"></el-option>
                  <el-option value="third-4" label="终审驳回"></el-option>
                  <el-option value="third-3" label="终审不通过"></el-option>
                </el-option-group>
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="$refs.supportTables.handleSearch()"
                >搜索
              </el-button>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="info-content">
        <div class="set-box">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <WtDataList
                  v-model="data.list"
                  :url="$url.studentApplication.list"
                  :pageSize="10"
                  :search="search"
                  ref="supportTables"
                >
                  <div slot="list" style="padding: 0 0 20px 0">
                    <el-table :data="data.list" style="width: 100%" ref="table">
                      <el-table-column label="姓名" width="100">
                        <template slot-scope="scope"
                          ><a
                            @click="cancelDialog(scope.row)"
                            style="color: blue; cursor: pointer"
                            >{{ scope.row.user_name }}</a
                          ></template
                        >
                      </el-table-column>
                      <el-table-column
                        label="资助高中"
                        width="150"
                        prop="school_name"
                      ></el-table-column>
                      <el-table-column
                        label="高中资助时间"
                        width="150"
                        prop="apply_date"
                      ></el-table-column>
                      <el-table-column
                        label="申请类型"
                        width="180"
                        prop="set_name"
                      ></el-table-column>
                      <el-table-column
                        label="就读大学"
                        prop="university"
                      ></el-table-column>
                      <el-table-column
                        label="大学属性"
                        width="120"
                        prop="education_text"
                      ></el-table-column>
                      <el-table-column
                        label="提交时间"
                        width="180"
                        prop="created_at"
                      ></el-table-column>
                      <el-table-column label="状态" width="150">
                        <template slot-scope="scope">
                          <div>
                            <div
                              v-if="
                                scope.row.audit_status == 1 &&
                                scope.row.college_student_apply_audit_num
                              "
                              style="color: sandybrown"
                            >
                              驳回修改并重新提交资料
                            </div>
                            <div
                              v-else-if="scope.row.audit_status == 1"
                              style="color: sandybrown"
                            >
                              {{ scope.row.audit_status_title }}
                            </div>
                            <div
                              v-else-if="scope.row.audit_status == 2"
                              style="color: green"
                            >
                              {{ scope.row.audit_status_title }}
                            </div>
                            <div
                              v-else-if="scope.row.audit_status == 3"
                              style="color: red"
                            >
                              {{ scope.row.audit_status_title }}
                            </div>
                            <div v-else style="color: #2d8cf0">
                              {{ scope.row.audit_status_title }}
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </WtDataList>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </div>
    </div>
    <el-drawer size="92%" @close="drClose" :visible.sync="drawer">
      <div slot="title">
        <div>
          {{ drawerTitle }}
          <el-tag
            size="mini"
            :color="auditStatusColor[info.apply.audit_status]"
            effect="dark"
            >{{ auditTypeText[info.apply.audit_type] || "初审"
            }}{{ auditStatusText[info.apply.audit_status] }}</el-tag
          >
        </div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-card shadow="never">
            <el-row :gutter="10">
              <el-col span="6">
                <div class="comiis_uhdd_tuser">
                  <div :class="['kmavt', info.sex == 1 ? 'man' : 'woman']">
                    <img :src="info.headimg_url" class="user_avatar" />
                  </div>
                  <div class="kminfo">
                    <div class="kmtit">
                      <span class="kmname"
                        >{{ info.name }}
                        <i
                          :class="
                            info.sex == 1
                              ? 'el-icon-user-solid'
                              : 'el-icon-s-custom'
                          "
                          :style="{
                            color: info.sex == 1 ? 'blue' : '#ff7878',
                            fontSize: '20px',
                          }"
                        ></i>
                        <img
                          v-if="info.picture"
                          :src="info.picture"
                          style="height: 14px; width: 14px"
                        />
                      </span>
                    </div>
                    <div class="kmtxt">
                      <span>电话：</span>{{ info.mobile }}
                    </div>
                    <div class="kmtxt">
                      <span>微信：</span>{{ info.wechat || "-" }}
                    </div>
                    <div class="kmtxt">
                      <span>QQ号：</span>{{ info.qq || "-" }}
                    </div>
                  </div>
                </div>
                <div class="other">
                  <div class="other-o">
                    <span>学历：</span>{{ info.education_value || "高中" }}
                  </div>
                  <div class="other-o">
                    <span>民族：</span>{{ info.nation_name || "-" }}
                  </div>
                  <div class="other-t">
                    <span>标签：</span>
                    <el-tag
                      v-for="(item, index) in info.student_tag"
                      :key="index"
                      :color="item.color"
                      :hit="false"
                      size="mini"
                      style="margin-right: 2px"
                      effect="dark"
                    >
                      {{ item.name }}
                    </el-tag>
                  </div>
                </div>
              </el-col>
              <el-col span="16">
                <el-table
                  :data="info.apply.audit_list"
                  border
                  height="150"
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="audit_user_name"
                    label="审核人"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="created_at"
                    label="审核时间"
                    width="170"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="audit_status"
                    label="审核结果"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column prop="audit_note" label="审核意见">
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col span="2">
                <template
                  v-if="info.apply.audit_type != 'last' && info.apply.is_audit"
                >
                  <template
                    v-if="
                      info.apply.audit_type == 'first' || !info.apply.audit_type
                    "
                  >
                    <el-button
                      v-if="!info.apply.recheck"
                      type="primary"
                      size="small"
                      @click="handleEdit(rowItem)"
                      >点击进行初审</el-button
                    >
                    <el-button
                      v-else-if="
                        info.apply.recheck && info.apply.audit_status == 2
                      "
                      type="primary"
                      size="small"
                      @click="handleEdit(rowItem)"
                      >点击进行复审</el-button
                    >
                    <el-button v-else type="info" size="small" disabled
                      >等待初审通过</el-button
                    >
                  </template>
                  <template v-else>
                    <el-button
                      v-if="info.apply.recheck"
                      type="primary"
                      size="small"
                      @click="handleEdit(rowItem)"
                      >点击进行复审</el-button
                    >
                  </template>
                </template>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="24" style="padding-top: 10px; margin-left: 10px">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-collapse v-model="activeNames">
                <!-- <el-collapse-item title="高中信息" name="1">
                  <el-descriptions
                    class="margin-top"
                    :column="2"
                    size="small"
                    border
                    :labelStyle="{
                      width: '90px',
                      fontWeight: 'bold',
                      color: '#333',
                      verticalAlign: 'middle',
                      textAlign: 'center',
                    }"
                  >
                    <el-descriptions-item :span="2">
                      <template slot="label"> 学校名称 </template>
                      {{ info.support_user.school_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 入学年份 </template>
                      {{ info.support_user.entrance_date }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 就读班级 </template>
                      {{ info.support_user.class }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 监护人 </template>
                      {{ info.support_user.guardian }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 联系电话 </template>
                      {{ info.mobile }}
                    </el-descriptions-item>
                    <el-descriptions-item :span="2">
                      <template slot="label"> 家庭住址 </template>
                      {{ info.support_user.home_address }}
                    </el-descriptions-item>
                    <el-descriptions-item :span="2">
                      <template slot="label"> 申请理由 </template>
                      {{ info.support_apply.apply_reason }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 班主任 </template>
                      {{ info.support_apply.teacher_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 联系电话 </template>
                      {{ info.support_apply.teacher_mobile }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-collapse-item> -->
                <el-collapse-item title="大学信息" name="2">
                  <el-alert
                    v-for="(item, index) in info.education"
                    :key="index"
                    style="margin-bottom: 6px; margin-top: 6px"
                    :closable="false"
                    type="warning"
                  >
                    <div slot="title">
                      {{ item.start_date }} - {{ item.end_date }}，{{
                        item.education_value
                      }}
                      <div>{{ item.school_name }}</div>
                      <div>{{ item.specialty_name }}</div>
                    </div>
                  </el-alert>
                </el-collapse-item>
              </el-collapse>
            </el-col>
            <el-col :span="18">
              <span
                v-for="(item, index) in info.apply.forms"
                :key="index"
                style="margin-right: 15px"
              >
                <el-avatar
                  style="margin-right: 2px"
                  :class="getCheck(it)"
                  size="small"
                  v-for="(it, idx) in item.forms"
                  :key="idx"
                  ><span v-if="it.is_quest!=1">{{ getNumber(index, it, idx) }}</span>
                  <span v-else>问</span>
                </el-avatar
                >
              </span>

              <el-tabs v-model="activeTabName">
                <el-tab-pane
                  :label="getTitle(item, index)"
                  :name="'apply_' + index"
                  v-for="(item, index) in info.apply.forms"
                  :key="index"
                >
                  <div
                    v-for="(it, idx) in item.forms"
                    :key="idx"
                    @click="showCollate(index, idx,it.is_quest)"
                    class="idx-con"
                  >
                    <el-alert
                      :type="
                        it.check == 1
                          ? 'success'
                          : it.check == 2
                          ? 'error'
                          : 'info'
                      "
                      :closable="false"
                      style="margin-bottom: 8px"
                      show-icon
                    >
                      <div slot="title">
                        {{ getSerialNumber(index, it, idx, "、") }}{{ it.name }}
                      </div>
                      <div>
                        <div class="iconSize" v-if="it.type == '图片上传'">
                          <el-image
                            v-for="(image, img) in it.value"
                            :key="img"
                            :src="image.data.url"
                            class="img"
                            fit="cover"
                            z-index="99999"
                            :preview-src-list="getImageUrls(it.value)"
                          >
                          </el-image>
                        </div>
                        <div class="iconSize" v-else-if="it.type == '单项矩阵' || it.type=='多选矩阵'">
                          <div>选择内容：{{ it.value?it.value.value:'' }}</div>
                          <div style="margin-top: 10px">其他说明：{{ it.value?it.value.other:'' }}</div>
                          <div style="margin-top: 10px">附件：
                            <div v-if="it.value && it.value.images">
                              <el-image v-for="(image, img) in it.value.images" :key="img" :src="image.data.url" class="img" fit="cover"
                                        z-index="99999" :preview-src-list="getImageUrls(it.value.images)">
                              </el-image>
                            </div>
                          </div>
                        </div>
                        <div class="iconSize" v-else>
                          {{ it.value
                          }}<a
                            v-if="
                              it.type == '公益活动' || it.type == '赋能课程'
                            "
                            class="desc-a"
                            @click.stop="showActivityList(it)"
                            >查看参与详情></a
                          >
                        </div>
                        <div>{{ it.error }}</div>
                      </div>
                    </el-alert>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-drawer>
    <el-dialog title="奖学金申请审核" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" :model="auditDataModal" label-width="100px">
        <el-form-item label="审核结果：">
          <el-radio-group v-model="auditDataModal.audit_status">
            <el-radio :label="2">审核通过</el-radio>
            <el-radio :label="4">驳回修改（允许编辑后重新登记）</el-radio>
            <el-radio :label="3">审核拒绝（不允许再进行登记）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input
            type="textarea"
            v-model="auditDataModal.audit_note"
            :rows="6"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditDataSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="内容审批" :visible.sync="contentVisible" width="40%">
      <el-form ref="form" :model="auditContentDataModal" label-width="100px">
        <el-form-item label="意见：">
          <el-radio-group v-model="auditContentDataModal.check">
            <el-radio :label="1">满足</el-radio>
            <el-radio :label="2">不满足</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因：">
          <el-input
            type="textarea"
            v-model="auditContentDataModal.error"
            :rows="4"
          ></el-input>
          快捷选项：
          <el-tag
            v-for="(item, index) in fastOption"
            :key="index"
            style="cursor: pointer; margin-right: 5px"
            size="small"
            @click="setContentAudit(item.name)"
            type="danger"
            effect="dark"
          >
            {{ item.name }}
          </el-tag>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contentVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditContentDataSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <activity-apply-list
      v-model="activityListShow"
      :searchData="activitySearch"
    ></activity-apply-list>
    <column-apply-list
      v-model="columnListShow"
      :searchData="activitySearch"
    ></column-apply-list>
  </div>
</template>

<script>
import ColumnApplyList from "./components/columnApplyList";
import ActivityApplyList from "./components/activityApplyList";
export default {
  components: {
    ColumnApplyList,
    ActivityApplyList,
  },
  props: {
    // 异步请求url
    tableName: {
      type: String,
      default: "university",
    },
  },
  name: "StudentApplication",
  data() {
    return {
      activeTabName: "apply_0",
      activeNames: ["1", "2"],
      contentVisible: false,
      info: {
        support_user: {},
        group_support: {},
        support_apply: {},
        visit_info: {},
        apply: {
          forms: [],
        },
        education: [],
      },
      rowItem: {},
      menuName: 1,
      active: "1",
      activeName: "name0",
      drawerTitle: "",
      drawer: false,
      title: "本专科奖学金",
      auditDataModal: {
        audit_status: 2,
        ids: [],
        audit_note: "",
      },
      auditContentDataModal: {
        check: 1,
        error: "",
      },
      auditStatusColor: {
        1: "sandybrown",
        2: "green",
        3: "red",
        4: "#2d8cf0",
      },
      auditStatusText: {
        1: "待审核",
        2: "通过",
        3: "不通过",
        4: "驳回",
      },
      auditTypeText: {
        first: "初审",
        second: "复审",
        last: "终审",
      },
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      radio: 3,
      dialogVisible: false,
      data: {},
      au: {},
      search: {
        tableName: this.tableName,
        year: new Date().getFullYear(),
      },
      fastOption: [],
      navStatus: 1,
      itemData: {},
      activityList: [],
      steps: [],
      formsData: [],
      index: 0,
      idx: 0,
      activitySearch: {},
      activityListShow: false,
      columnListShow: false,
    };
  },
  methods: {
    getCheck(it) {
      if (it.is_quest==1){
        return "quest";
      }else{
        if (it.check == 1) {
          return "success";
        }
        if (it.check == 2) {
          return "error";
        }
      }
    },
    getNumber(index, it, idx) {
      let length = 0;
      for (let i = 0; i < index; i++) {
        length += this.info.apply.forms[i].forms.length; //把前面题目数量累加
      }
      return length + idx + 1;
    },
    getSerialNumber(index, it, idx, suffix = "") {
      if (/^\d+[\.|、]/.test(it.name)) {
        return "";
      }
      return this.getNumber(index, it, idx) + "" + suffix;
    },
    handleEdit(data) {
      this.auditDataModal.ids = [];
      this.auditDataModal.ids.push(data.id);
      // this.auditDataModal.money = data.t_money;
      //把错误信息进行组成
      let remark = "";
      let that = this;
      this.info.apply.forms.forEach((item, index) => {
        let length = 0;
        let error = "";
        //先计算前面有几题
        for (let i = 0; i < index; i++) {
          length += that.info.apply.forms[i].forms.length; //把前面题目数量累加
        }
        item.forms.forEach((it, idx) => {
          if (it.check == 2) {
            error += "第" + (length + idx + 1) + "项" + it.error + "；";
            error += "\n";
          }
        });
        remark += error;
      });
      this.auditDataModal.audit_note = remark;
      this.dialogVisible = true;
    },
    getTitle(item, index) {
      let first = 0;
      let last = 0;
      let length = 0;
      let forms_length = item.forms.length; //当前选择有多少题
      for (let i = 0; i < index; i++) {
        length += this.info.apply.forms[i].forms.length; //把前面题目数量累加
      }
      first = length + 1;
      last = forms_length + length;
      return item.title + "（" + first + "~" + last + "）";
    },
    setContentAudit(text) {
      let error = this.auditContentDataModal.error;
      this.auditContentDataModal.error = error + text + "";
    },
    auditContentDataSubmit() {
      this.$set(
        this.info.apply.forms[this.index].forms[this.idx],
        "check",
        this.auditContentDataModal.check
      );
      this.$set(
        this.info.apply.forms[this.index].forms[this.idx],
        "error",
        this.auditContentDataModal.error
      );
      this.auditContentDataModal.error = "";
      this.contentVisible = false;
    },
    showCollate(index, idx,is_quest) {
      if (is_quest != 1){
        this.index = index;
        this.idx = idx;
        this.contentVisible = true;
      }
    },
    onSelect(name) {
      this.menuName = name;
    },
    arrEuqalse(arr1, arr2) {
      if (!arr1 || !arr2) {
        return false;
      }
      var array = arr1.split(",");
      for (var index = 0; index < arr2.length; index++) {
        for (var j = 0; j < array.length; j++) {
          if (arr2[index] == array[j]) {
            return true;
          }
        }
      }
      return false;
    },
    drClose() {
      this.active = "1";
      this.menuName = 1;
    },
    cancelDialog(item) {
      this.rowItem = item;
      this.drawerTitle = item.user_name + item.set_name + "信息";
      this.$db.post(this.$url.dict.list).then((resp) => {
        this.fastOption = resp.data.fastOption;
      });
      this.$db
        .get(this.$url.studentApplication.url + "/" + item.id)
        .then((resp) => {
          this.info = resp.data;
          if (!resp.data.support_user) {
            this.info.support_user = {};
          }
          if (!resp.data.support_apply) {
            this.info.support_apply = {};
          }
          if (!resp.data.visit_info) {
            this.info.visit_info = {};
          }
        });
      //查询相关信息
      this.drawer = true;
    },
    expandChange(row, expandedRows) {},
    toogleExpand(row) {
      let $table = this.$refs.table;
      $table.toggleRowExpansion(row, false);
    },
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    auditDataSubmit() {
      let self = this;
      let forms = this.info.apply.forms;
      //首先看每个选项是否都进行了内容审批
      let check = [];
      forms.forEach((element) => {
        element.forms.forEach((el) => {
          check.push(el.check ? el.check : false);
        });
      });
      if (
        check[0] === false ||
        check[1] === false ||
        check[check.length - 1] === false ||
        check[check.length - 2] === false
      ) {
        this.$notify({
          title: "提示信息",
          message: "第1、2、22、23项必须进行审核",
          type: "error",
        });
        return false;
      }
      self.auditDataModal.forms = this.info.apply.forms;
      self.$db
        .post(self.$url.studentApplication.audit, self.auditDataModal)
        .then((resp) => {
          if (resp) {
            this.$notify({
              title: "提示信息",
              message: "审核成功",
              type: "success",
            });
            //刷新窗口
            self.$refs.supportTables.reloadTable();
            self.dialogVisible = false;
          }
          self.auditDataModal.audit_status = 2;
          self.auditDataModal.audit_note = "";
          self.auditDataModal.ids = [];
        });
    },
    // 显示参与情况
    showActivityList(data) {
      this.activitySearch = {
        apply_user_id: this.info.apply.user_id,
        activity_type: data.activity_type,
      };
      if (data.type == "公益活动") {
        this.activityListShow = true;
      } else {
        this.columnListShow = true;
      }
    },
    // 取图片集合里面的url
    getImageUrls(images){
      if(!images.length){
        return [];
      }
      let urls = [];
      images.map(item => {
        urls.push(item.data.url);
      });
      return urls;
    }
  },
  watch: {
    $route(newRoute) {
      this.title = newRoute.meta.title;
      this.search.tableName = this.tableName;
      this.$refs.supportTables.handleSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;

    > p {
      color: #414c60;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }

    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
  }

  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 1.6666666666666666vh;
    padding-bottom: 4.351851851851852vh;

    .list-box {
      height: 19.518518518518517vh;
      width: 10.416666666666667vw;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      .list-time {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        overflow: hidden;

        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          text-align: center;
          margin-top: 4.814814814814815vh;

          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }

        > i {
          display: block;
          width: 100%;
          font-style: normal;
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          // margin-top: 0.7259259259259259vh;
          text-align: center;
        }
      }

      .list-top {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;

        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          line-height: 13.796296296296295vh;
          text-align: center;

          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }

        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 13.796296296296295vh;
          text-align: center;
        }
      }

      .list-bottom {
        height: 4.6296296296296294vh;
        position: relative;

        > p {
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          line-height: 1.4814814814814815vh;
          padding-left: 0.7291666666666667vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          > span {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #1caee0;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }

    .set-box {
      //height: 19.518518518518517vh;
      //width: 30.833333333333335vw;
      width: 100%;
      padding: 15px;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;

      .set-info {
        padding-left: 9.895833333333333vw;
        height: 100%;
        position: relative;
        overflow: hidden;

        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }

        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 2.2222222222222223vh;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }

        > p {
          color: #8d95a4;
          font-size: 1.6666666666666666vh;
          line-height: 1.6666666666666666vh;
          margin-bottom: 1.2962962962962963vh;
        }
      }

      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;

        > h5 {
          font-weight: normal;
          font-size: 3.333333333333333vh;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }

        > p {
          color: #1caee0;
          font-size: 1.4814814814814815vh;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}

.c-bottom {
  display: flex;
  justify-content: space-between;

  .public-box {
    width: 100%;
    padding-bottom: 6.066666666666667vh;

    .public-title {
      display: flex;
      justify-content: space-between;
      width: 100%;

      > p {
        color: #414c60;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }

      > h5 {
        font-weight: normal;
        color: #8d95a4;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }
    }

    .train-box {
      width: 100%;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      margin-top: 1.6666666666666666vh;
      border: solid 1px #e6e7eb;
      overflow: hidden;

      .train-top {
        width: 100%;
        height: 34.16666666666667vh;

        > ul {
          padding: 4.6296296296296294vh 2.1875vw;

          > li {
            list-style: none;
            display: flex;
            margin-bottom: 5.3703703703703705vh;

            &:last-child {
              margin-bottom: 0;
            }

            .left-box {
              height: 4.4444444444444446vh;
              width: 5vw;
              border-right: 1px solid #e4e5e9;

              > h5 {
                font-weight: normal;
                color: #bfc0c8;
                font-size: 2.7777777777777776vh;
                line-height: 2.7777777777777776vh;
              }

              > p {
                font-size: 1.4814814814814815vh;
                color: #bfc0c8;
              }
            }

            .right-box {
              padding-left: 1.5625vw;
              > h5 {
                color: #414c60;
                font-size: 1.6666666666666666vh;
                line-height: 1.6666666666666666vh;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
                margin-bottom: 1.0037037037037037vh;
              }

              > p {
                color: #8d95a4;
                font-size: 1.2962962962962963vh;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
            }
          }
        }
      }

      .term-box {
        width: 100%;
        height: 34.16666666666667vh;

        > ul {
          padding: 4.6296296296296294vh 2.1875vw;

          li {
            list-style: none;
            display: flex;
            margin-bottom: 5vh;

            &:last-child {
              margin-bottom: 0;
            }

            > p {
              width: 4.0625vw;
              height: 2.3148148148148147vh;
              border-right: 1px solid #e4e5e9;
              font-size: 2.2222222222222223vh;
              line-height: 2.3148148148148147vh;
              color: #bfc0c8;
            }

            .score-box {
              width: 29.635416666666664vw;
              display: flex;
              justify-content: space-between;
              padding-left: 1.3020833333333334vw;

              > h5 {
                color: #414c60;
                font-size: 1.6666666666666666vh;
                line-height: 2.3148148148148147vh;
              }

              > p {
                > span {
                  font-size: 2.3666666666666666vh;
                  line-height: 2.3148148148148147vh;
                  color: #414c60;
                }
              }
            }
          }
        }
      }

      .train-bottom {
        height: 10.092592592592593vh;
        background-color: #1caee0;
        position: relative;

        > p {
          font-size: 2.2222222222222223vh;
          color: #fff;
          font-weight: 600;
          padding-left: 3.4895833333333334vw;
          line-height: 4.6296296296296294vh;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          > span {
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #1caee0;
            font-size: 4.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }

          > i {
            font-style: normal;
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #feb64d;
            font-size: 2.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
        }
      }
    }
  }
}

.comiis_uhdd_tuser {
  display: flex;
  align-items: center;
  .kmavt {
    position: relative;
    margin-right: 15px;
    background: #fff;
    min-width: 100px;
    height: 100px;
    border-radius: 50%;
  }
  .man {
    box-shadow: 0px 0px 6px 4px rgba(141, 163, 247, 0.4);
  }
  .woman {
    box-shadow: 0px 0px 6px 4px rgba(255, 120, 120, 0.4);
  }
}
.other {
  padding-top: 14px;
  font-size: 13px;
  .other-o {
    width: 34%;
    display: inline-block;
    color: #666;
    > span {
      color: #999;
    }
  }
  .other-t {
    padding-top: 6px;
    > span {
      color: #999;
    }
  }
}

img.user_avatar,
.slideimage img {
  vertical-align: middle;
}

.comiis_uhdd_tuser .kmavt img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  object-fit: cover;
}

.comiis_uhdd_tuser .kmtit {
  height: 38px;
}

.comiis_uhdd_tuser .kmname {
  line-height: 28px;
  font-size: 20px;
  font-weight: 400;
  overflow: hidden;
}

.comiis_uhdd_tuser .kmtxt {
  margin-top: 6px;
  font-size: 13px;
  color: #666;
  overflow: hidden;
  > span {
    color: #999;
  }
}

.success {
  background-color: #67c23a;
}
.quest {
  background-color: #2d8cf0;
}
.error {
  background-color: #f56c6c;
}
.img {
  width: 90px;
  height: 90px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 6px;
}
.idx-con {
  cursor: pointer;
}
.desc-a {
  color: #2d8cf0 !important;
  font-size: 12px;
  text-decoration: underline;
  padding-left: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/college/support.vue